import { PDFDocument } from 'pdf-lib'
import dataToArrayBuffer from 'helpers/browser/dataToArrayBuffer'

const getPdfSizes = async (pdfBlob) => {
  if (pdfBlob) {
    const pdfData = await dataToArrayBuffer(pdfBlob, 'application/pdf')
    const pdf = await PDFDocument.load(pdfData)

    return pdf.getPages().map((page) => {
      return page.getSize()
    })
  }

  return 0
}

export default getPdfSizes
